import { render, staticRenderFns } from "./RequestManagerItem.vue?vue&type=template&id=b9e06e16&scoped=true&"
import script from "./RequestManagerItem.vue?vue&type=script&lang=js&"
export * from "./RequestManagerItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestManagerItem.vue?vue&type=style&index=0&id=b9e06e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e06e16",
  null
  
)

export default component.exports